import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import moment from "moment"

import Modal from "react-modal"
import Button from "./Button"

import { CUSTOM_MODAL_TYPES } from "constants/modal-types"

import ErrorIcon from "assets/icons/error.svg"
import SuccessIcon from "assets/icons/success.svg"
import WarningIcon from "assets/icons/warning.svg"

// Import styles
import "styles/components/common/response-modal.scss"

const iconTypes = {
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
}

class ResponseModal extends Component {
  renderModal() {
    const {
      modalContent,
      modalAction,
      school: { schoolData },
      closeModal,
    } = this.props

    return modalContent.modalType === CUSTOM_MODAL_TYPES.SCHEDULE ? (
      <Fragment>
        <div
          className="response-modal-header"
          style={{ color: schoolData.primary_color }}
        >
          Class Schedule
        </div>
        <h3 className="batch-name">{modalContent.data.class}</h3>
        {modalContent.data.data.map((item, index) => (
          <div className="batch-container" key={index}>
            <p className="batch-year" key={index}>
              {Object.keys(item)}
            </p>
            <div className="batch-list">
              {item[Object.keys(item)].map((content, i) => (
                <div className="batch-item" key={i}>
                  <div className="date-container" key={i}>
                    <p className="month">
                      {moment(content.date).format("MMM").toString()}
                    </p>
                    <p
                      className="day"
                      style={{ color: schoolData.primary_color }}
                    >
                      {moment(content.date).format("DD").toString()}
                    </p>
                  </div>
                  <div className="info-container">
                    <div className="label-container">
                      <p className="label">Time:</p>
                      <p className="label">Instructor:</p>
                      <p className="label">Type:</p>
                    </div>
                    <div className="text-container">
                      <p className="label">{`${content.start_time} - ${content.end_time}`}</p>
                      <p className="label">{content.instructor}</p>
                      <p className="label">{content.type}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        <Button label={modalContent.actionLabel} onClick={modalAction} />
      </Fragment>
    ) : (
      <Fragment>
        <span className="response-modal-icon">
          <img src={iconTypes[modalContent.modalType]} alt="SUCCESS" />
        </span>
        {modalContent.header && (
          <span className={`response-modal-header ${modalContent.modalType}`}>
            {modalContent.header}
          </span>
        )}
        <p className="response-modal-message">{modalContent.message}</p>

        <div className="button-group">
          <Button label={modalContent.actionLabel} onClick={modalAction} />
          {modalContent.showCloseModal && (
            <Button label="Close" onClick={() => closeModal()} ghost />
          )}
        </div>
      </Fragment>
    )
  }

  render() {
    const { isOpen, closeModal } = this.props

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        className="response-modal"
        overlayClassName="response-modal-overlay -darker"
      >
        <Fragment>
          <div className="response-modal-container">{this.renderModal()}</div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(ResponseModal)
